/**
=========================================================
* Otis Kit PRO - v2.0.1
=========================================================

* Product Page: https://material-ui.com/store/items/otis-kit-pro-material-kit-react/
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from 'react';

// Otis Kit PRO components
import MKBox from "../MKBox";
import MKTypography from "../MKTypography";

interface ListItemProps {
  title: string;
}

function ListItem({ title }: ListItemProps) {
  return (
    <MKBox p={2}>
      <MKTypography variant="h5">
        {title}
      </MKTypography>
    </MKBox>
  );
}

export default ListItem;
